module.exports = __webpack_public_path__ + "media/assets/avia/search/plane_orange-33bc063b2c01f2643eb00b70fd37da7c.png";